import css from './feedback.module.css';
import type { ApiError } from '@/api/client';

interface Props {
  error: ApiError | Error | string | null | undefined;
  retry?: () => void;
}

export function ErrorState({ error, retry }: Props) {
  const message =
    typeof error === 'string'
      ? error
      : error && 'message' in (error as object)
        ? (error as { message: string }).message
        : 'Unknown error';

  return (
    <div className={css.errorWrap} role="alert">
      <div className={css.errorIcon} aria-hidden>⚠️</div>
      <div className={css.errorTitle}>Something went wrong</div>
      <div className={css.errorMessage}>{message}</div>
      {retry && (
        <button className={css.retryButton} onClick={retry}>
          Retry
        </button>
      )}
    </div>
  );
}
